import {colors} from '@xpertdox_js/xdstyle';
const button = {
  padding: '10px 12px',
  width: '11rem'
}

export default {
  searchBarContainer: {
    width: '50%',
  },
  searchBar: {
    width: '90%',
  },
  nctContainer: {
    borderRadius: 3,
    background: '#4d565d',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 15,
    margin: '0px 10px 5px 3px',
  },
  nct: {
    fontSize: '1.1rem',
    display: 'flex',
    flexWrap: 'wrap',
  },
  icon: {
    height: 15,
    width: 15,
    transform: 'translate(7px, -0.5px)',
    cursor: 'pointer',
    fill: 'white',
    color: 'white'
  },
  p: {
    fontSize: '1.4rem',
    fontWeight: '500',
    margin: 0,
    paddingLeft: 5,
    marginBottom: 8,
  },
  logScroll: {
    maxHeight: '100%',
    padding: 10,
  },
  download: {
    background: colors.xdHighlight,
    height: 25,
    padding: 5,
    position: 'absolute',
    top: 5,
    right: 5
  },
  modal: {
    maxWidth: 500,
    maxHeight: 122,
    height: 122,
  },
  content: {
    background: '#fff',
    boxShadow: '0 16px 12px -12px rgba(0,0,0,0.2)',
    padding: '10px',
    maxWidth: '500px',
    borderRadius: '2px',
    minHeight: '120px',
  },
  heading: {
    fontWeight: 'bold',
    fontSize: '1.5rem'
  },
  question: {
    margin: '2px 0 16px',
    fontSize: '1.8rem',
  },
  accept: {
    ...button,
    background: '#16b867'
  },
  acceptHov: {
    background: '#19cf74'
  },
  cancel: {
    ...button,
    background: '#4d565d'
  },
  cancelHov: {
    background: '#E62712'
  },
  nctHover: {
    background: '#cd4d4e',
  },
}
